module.exports = __webpack_public_path__ + "img/aun-no-decide-por-quien-votara.f95ffb03.png";